import React, { useState } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "component/common/ErrroMessage/index";
import PasswordInput from "component/common/PasswordInput";
import { changePassword } from "service/Auth";
import { Toast } from "utils/toast";
import { logout } from "utils/helper";
import PasswordSuccess from "./PasswordSuccess";

import styles from "./ChangePassword.module.scss";

const ChangePassword = ({ toggle }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    reset,
  } = useForm();

  let [isOpen, setIsOpen] = useState(false);

  const onSubmit = async (data) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let body = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    };
    try {
      let response = await changePassword(user._id, body);
      if (response.status == 200) {
        reset({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        setIsOpen(true);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const togglePopUp = () => {
    setIsOpen(!isOpen);
    logout();
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 mb-3">
          <PasswordInput
            label="Old Password"
            register={register("oldPassword", { required: true })}
            error={errors.oldPassword}
          />
          <ErrorMessage
            error={errors.oldPassword}
            message={{
              required: "Please enter old password",
            }}
          />
        </div>
        <div className="col-md-12 mb-3">
          <PasswordInput
            label="New Password"
            register={register("newPassword", {
              required: true,
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d@$#!%*?&]{8,}$/,
            })}
            error={errors.newPassword}
          />
          <ErrorMessage
            error={errors.newPassword}
            message={{
              required: "Please enter new password",
            }}
          />
          {errors.newPassword?.type !== "required" && (
            <div
              className={styles.password_note}
              style={{ color: errors.newPassword ? "red" : "green" }}
            >
              <i className="bi bi-exclamation-circle"></i>
              <span>
                Password contains atleast 8 character includes one captial
                letter, symbol, number
              </span>
            </div>
          )}
        </div>
        <div className="col-md-12 mb-3">
          <PasswordInput
            label="Confirm Password"
            register={register("confirmPassword", {
              required: true,
              validate: () =>
                getValues("newPassword") === getValues("confirmPassword"),
            })}
            error={errors.confirmPassword}
          />
          <ErrorMessage
            error={errors.confirmPassword}
            message={{
              required: "Please enter confirm password",
              validate: "Confirm password is not match with New Password",
            }}
          />
        </div>
        <div className="col-md-12 text-center">
          <button className={styles.reset_btn} onClick={handleSubmit(onSubmit)}>
            RESET
          </button>
        </div>
      </div>
      <PasswordSuccess isOpen={isOpen} toggle={togglePopUp} />
    </>
  );
};

export default ChangePassword;
